import React, { useRef, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CssBaseline from "@mui/material/CssBaseline";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import FaceIcon from "@mui/icons-material/Face";
import DoneIcon from "@mui/icons-material/Done";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CSVLink, CSVDownload } from "react-csv";

import SalesInvoiceProducts from "./SalesInvoiceProducts";
import axios from "axios";
import { format, parseISO } from "date-fns";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// PDF
import { jsPDF } from "jspdf";
import "jspdf-autotable";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";

import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import InputAdornment from "@mui/material/InputAdornment";
import EventIcon from "@mui/icons-material/Event";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import EditSalesInvoiceSummary from "./EditSalesInvoiceSummary/EditSalesInvoiceSummary";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      padding: ".2rem",
    },
  },
}));

const filter = createFilterOptions();

function ViewSalesInvoiceSummary(props) {
  const defaultStartingDate = new Date();
  defaultStartingDate.setMonth(defaultStartingDate.getMonth() - 1); // For subtract use minus (-)

  const classes = useStyles();
  const [autoSuggestProducts, setAutoSuggestProducts] = useState(null);
  const [openSaleOrderProductDialog, setOpenSaleOrderProductDialog] = useState(false);
  const [salesInvoices, setSalesInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState();
  //const [searchAccountTerm, setSearchAccountTerm] = useState({name:""});

  const [searchTerm, setSearchTerm] = useState({ name: "" });
  const [autoSuggestAccounts, setAutoSuggestAccounts] = useState([]);
  const [autoSuggestSalesman, setAutoSuggestSalesman] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");
  const [searchByAnchorElement, setSearchByAnchorElement] = React.useState(null);
  const [searchBy, setSearchBy] = useState("search_by_account_name");
  const [openDateFilterDialog, setOpenDateFilterDialog] = useState(false);
  const [startingDate, setStartingDate] = React.useState(defaultStartingDate);
  const [openStartingDateCalendar, setOpenStartingDateCalendar] = useState(false);
  const [endingDate, setEndingDate] = React.useState(new Date());
  const [openEndingDateCalendar, setOpenEndingDateCalendar] = useState(false);
  const [startingFilterDate, setStartingFilterDate] = useState(defaultStartingDate);
  const [endingFilterDate, setEndingFilterDate] = useState(new Date());
  const [totalFilteredInvoiceSalesAmount, setTotalFilteredInvoiceSalesAmount] = useState(0);
  const [totalFilteredInvoiceCount, setTotalFilteredInvoiceCount] = useState(0);
  const [totalUniqueSKUcount, setTotalUniqueSKUcount] = useState(0);
  const [totalPerInvoiceUniqueSkuCount, setTotalPerInvoiceUniqueSkuCount] = useState(0);
  const [loadData, setLoadData] = useState(true);
  const [accountsLabel, setAccountLabel] = useState({});
  const [isLoadingAccountLabel, setIsLoadingAccountLabel] = useState(true);

  // Elipsis Element
  const [orderMenuAnchorElement, setOrderMenuAnchorElement] = useState(null);

  // Print via bluetooth
  const [loadingToConnectInBluetooth, setLoadingToConnectInBluetooth] = useState(false);
  const [isBluetoothConnected, setIsBluetoothConnected] = useState(false);
  const characteristicRef = useRef(null);

  // Progress Dialog
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressDialogMessage, setProgressDialogMessage] = useState("");

  // Alert Message Dialog
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");

  // SelectedInvoices
  const [selectedInvoices, setSelectedInvoices] = useState(null);

  // Download PDF
  const [downloadPDF, setDownloadPDF] = useState(false);
  const [selectedInvoicesForPdf, setSelectedInvoicesForPdf] = useState([]);

  // Download CSV
  const downloadCsvInvoiceRef = useRef();
  const [invoiceCSV, setInvoiceCSV] = useState([]);

  // Edit Invoices
  const [openEditInvoiceDialog, setOpenEditInvoiceDialog] = useState(false);
  const [toEditSelectedInvoices, setToEditSelectedInvoices] = useState(null);

  const searchByBtnHandleClick = (event) => {
    setSearchByAnchorElement(event.currentTarget);
  };

  const searchByBtnHandleClose = (event) => {
    setSearchTerm({ name: "" });
    setSearchBy(event.currentTarget.getAttribute("search_by"));
    setSearchByAnchorElement(null);
  };

  useEffect(() => {
    if (!isLoadingAccountLabel) {
      return;
    }

    const getAccountsLabel = () => {
      const options = {
        method: "POST",
        url: "/TransactiLabels/getTransactiLiteLabels.json",
      };

      axios(options)
        .then((res) => {
          const labels = res.data.response;
          const accountLabel = labels.accounts;
          const accountClassificationsLabel = labels.account_classifications;

          setAccountLabel(accountLabel);
          setIsLoadingAccountLabel(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getAccountsLabel();
  }, [accountsLabel, isLoadingAccountLabel]);

  function searchByDropdownMenu() {
    return (
      <Menu
        id="simple-menu"
        anchorEl={searchByAnchorElement}
        keepMounted
        open={Boolean(searchByAnchorElement)}
        onClose={() => {
          setSearchByAnchorElement(null);
        }}
      >
        <MenuItem onClick={searchByBtnHandleClose} search_by={"search_by_account_name"}>
          Search by {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural}{" "}
          Name
        </MenuItem>
        {/* <MenuItem onClick={searchByBtnHandleClose} search_by={"search_by_salesman_name"}>
          Search by Salesman Name
        </MenuItem> */}
        <Divider />
        <MenuItem
          onClick={() => {
            setSearchByAnchorElement(null);
            setOpenDateFilterDialog(true);
          }}
        >
          Select date filter
        </MenuItem>
      </Menu>
    );
  }
  function searchAccountName() {
    return (
      <div position="static">
        Search by {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} name
        <Toolbar
          variant="dense"
          style={{
            border: ".1rem solid #989898",
            borderRadius: "4px",
            margin: "2px",
          }}
        >
          <Box flexGrow={1}>{searchByAccountNameAutoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                getSalesInvoices(searchTerm.name);
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton className={classes.margin} size="large" onClick={searchByBtnHandleClick}>
              <MoreVertIcon />
            </IconButton>
          </Box>
          {searchByDropdownMenu()}
        </Toolbar>
      </div>
    );
  }
  function searchBySalesman() {
    return (
      <div position="static">
        Search by salesman name
        <Toolbar
          variant="dense"
          style={{
            border: ".1rem solid #989898",
            borderRadius: "4px",
            margin: "2px",
          }}
        >
          <Box flexGrow={1}>{searchBySalesmanAutoComplete()}</Box>
          <Box>
            <IconButton className={classes.margin} size="large">
              <SearchIcon
                onClick={() => {
                  getSalesInvoices(searchTerm.name);
                }}
              />
            </IconButton>
          </Box>
          <Box>
            <IconButton className={classes.margin} size="large">
              <MoreVertIcon onClick={searchByBtnHandleClick} />
            </IconButton>
          </Box>
          {searchByDropdownMenu()}
        </Toolbar>
      </div>
    );
  }
  function searchByAccountNameAutoComplete() {
    return (
      <Autocomplete
        value={searchTerm.name}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue === null || newValue.name === "") {
            searchTerm.name = "";
            return;
          }

          searchTerm.name = newValue.name;
          getSalesInvoices(newValue.name);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestAccounts}
        isOptionEqualToValue={() => true}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.name;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name + option.id}>
              {option.name}
            </li>
          );
        }}
        style={{ width: "100%" }}
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }

  function searchBySalesmanAutoComplete() {
    return (
      <Autocomplete
        value={searchTerm.name}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue == null || newValue.salesman_name === "") {
            searchTerm.name = "";
            return;
          }

          searchTerm.name = newValue.salesman_name;

          getSalesInvoices(newValue.salesman_name);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestSalesman}
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.salesman_name;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.salesman_name + option.id}>
              {option.salesman_name}
            </li>
          );
        }}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }

  function salesInvoiceOnClick(invoice) {
    setSelectedInvoice(invoice);
    setOpenSaleOrderProductDialog(true);
  }

  function formatDate(dateString) {
    try {
      return format(parseISO(dateString), "MMMM d,yyyy");
    } catch (err) {
      return "";
    }
  }

  function formatDate_(dateString) {
    try {
      return format(parseISO(dateString), "yyyy-mm-dd");
    } catch (err) {
      return "";
    }
  }
  function formatDateWithHour(dateString) {
    try {
      return format(parseISO(dateString), "MMMM d,yyyy hh:mm a");
    } catch (err) {
      return "";
    }
  }

  function headerSummary() {
    return (
      <div className={classes.paper}>
        <Paper elevation={3} style={{ padding: "16px", backgroundColor: "yellow" }}>
          <Typography variant="body1" gutterBottom>
            <strong>Date:</strong> {format(startingFilterDate, "MMM d, yyyy")} -{" "}
            {format(endingFilterDate, "MMM d, yyyy")}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Total invoice amount:</strong>{" "}
            {Number(totalFilteredInvoiceSalesAmount).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Total Unique SKUs Sold:</strong> {totalUniqueSKUcount}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Total Number of Invoices:</strong> {totalFilteredInvoiceCount}
          </Typography>
        </Paper>
      </div>
    );
  }

  function salesInvoiceItemBackup(salesInvoice) {
    return (
      <>
        <Grid
          container
          spacing={2}
          style={{ position: "relative" }}
          onClick={() => {
            salesInvoiceOnClick(salesInvoice);
          }}
        >
          <Grid item xs={12} style={{ position: "relative" }}>
            <IconButton
              component="span"
              size="large"
              onClick={(event) => {
                event.stopPropagation();
                setOrderMenuAnchorElement(event.currentTarget);
                setSelectedInvoices(salesInvoice);
              }}
              style={{ position: "absolute", top: 8, right: 8 }} // Adjust top and right as needed
            >
              <MoreVertIcon />
            </IconButton>
            <Grid container spacing={2}>
              <Grid item xs={12} sm container direction="column">
                <Grid item xs>
                  <Typography gutterBottom variant="subtitle1">
                    {Object.keys(accountsLabel).length === 0 ? "Account" : accountsLabel.singular}{" "}
                    name : {salesInvoice.account_name}
                    <br />
                    {/* {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} code: {salesInvoice.account_code}<br /> */}
                    Number of unique SKU sold: {salesInvoice.number_of_uniques_sku_sold}
                    <br />
                    Total value:{" "}
                    {Number(salesInvoice.total_value).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    <br />
                    Invoice date: {formatDate(salesInvoice.invoice_date)}
                    <br />
                    {/* Invoice type : {salesInvoice.invoice_type}
                    <br /> */}
                    {/* Created date : {formatDateWithHour(salesInvoice.created)}<br /> */}
                    {/* Salesman name : {salesInvoice.salesman_first_name}{" "}
                    {salesInvoice.salesman_last_name}
                    <br /> */}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function salesInvoiceItem(salesInvoice) {
    return (
      <>
        <Grid
          container
          spacing={2}
          style={{ position: "relative" }}
          onClick={() => {
            salesInvoiceOnClick(salesInvoice);
          }}
        >
          <Grid item xs={12} style={{ position: "relative" }}>
            <IconButton
              component="span"
              size="large"
              onClick={(event) => {
                event.stopPropagation();
                setOrderMenuAnchorElement(event.currentTarget);
                setSelectedInvoices(salesInvoice);
              }}
              style={{ position: "absolute", top: 8, right: 8 }} // Adjust top and right as needed
            >
              <MoreVertIcon />
            </IconButton>
            <Grid container spacing={2}>
              <Grid item xs={12} sm container direction="column">
                <Grid item xs>
                  <Typography gutterBottom variant="subtitle1">
                    {salesInvoice.account_name}
                    <br />
                    {salesInvoice.account_address}
                    <br />
                    {/* {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} code: {salesInvoice.account_code}<br /> */}
                    Number of unique SKU sold: {salesInvoice.number_of_uniques_sku_sold}
                    <br />
                    Total value:{" "}
                    {Number(salesInvoice.total_value).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    <br />
                    Invoice date: {formatDate(salesInvoice.invoice_date)}
                    <br />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  const orderMoreVertDropdownMenu = () => {
    return (
      <Menu
        id="simple-menu"
        anchorEl={orderMenuAnchorElement}
        keepMounted
        open={Boolean(orderMenuAnchorElement)}
        onClose={() => {
          setOrderMenuAnchorElement(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setOrderMenuAnchorElement(null);
          }}
        >
          <Button
            size="small"
            autoFocus
            color="success"
            className={classes.printBtn}
            startIcon={<PrintIcon />}
            onClick={(e) => {
              e.stopPropagation();
              handleConnectToBluetooth();
            }}
          >
            Print Via bluetooth
          </Button>
        </MenuItem>

        <MenuItem
          onClick={() => {
            setOrderMenuAnchorElement(null);
          }}
        >
          <Button
            size="small"
            autoFocus
            color="success"
            className={classes.printBtn}
            startIcon={<PictureAsPdfIcon />}
            onClick={(e) => {
              e.stopPropagation();
              setDownloadPDF(true);
              setSelectedInvoicesForPdf(selectedInvoices);
            }}
          >
            Download AS PDF
          </Button>
        </MenuItem>

        <MenuItem
          onClick={() => {
            setOrderMenuAnchorElement(null);
          }}
        >
          <CsvDownloadBtn />
        </MenuItem>

        {/* Agreed upon by nestle and sir Migs to hide the editing of invoices  while the control measures are not yet defined */}
        {/* <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            setOrderMenuAnchorElement(null);
          }}
        >
          <EditInvoicesBtn />
        </MenuItem> */}
      </Menu>
    );
  };

  function CsvDownloadBtn() {
    return (
      <>
        <CSVLink
          data={invoiceCSV}
          ref={downloadCsvInvoiceRef}
          filename={"Sales Invoice Summary.csv"}
          style={{ display: "none" }}
        />

        <Button
          size="small"
          autoFocus
          color="success"
          className={classes.printBtn}
          startIcon={<FileDownloadIcon />}
          onClick={(e) => {
            e.stopPropagation();
            handleDownloadInvoiceViaCSV();
          }}
        >
          Download AS CSV
        </Button>
      </>
    );
  }

  function EditInvoicesBtn() {
    return (
      <>
        <Button
          size="small"
          autoFocus
          color="success"
          className={classes.printBtn}
          startIcon={<BorderColorIcon />}
          onClick={(e) => {
            e.stopPropagation();

            if (isPast30Days(selectedInvoices.invoice_date)) {
              setShowMessageDialog(true);
              setMessageDialogMessage("You cannot edit invoices past 30 days");
              return;
            }

            setOpenEditInvoiceDialog(true);
            // selectedInvoices
          }}
        >
          Edit Invoices
        </Button>
      </>
    );
  }

  function isPast30Days(invoiceDate) {
    const invoiceTime = new Date(invoiceDate).getTime(); // Convert invoice date to timestamp
    const currentTime = new Date().getTime(); // Get current timestamp
    const thirtyDays = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

    return currentTime - invoiceTime > thirtyDays; // Check if difference is more than 30 days
  }

  async function handleDownloadInvoiceViaCSV() {
    const invoiceItems = selectedInvoices.InvoiceItems;
    const salesman_name =
      selectedInvoices.salesman_first_name +
      " " +
      selectedInvoices.salesman_middle_name +
      " " +
      selectedInvoices.salesman_last_name;
    const total_value = parseFloat(selectedInvoices.total_value).toFixed(2);

    const invoice_date = new Date(selectedInvoices.invoice_date);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formatted_invoice_date = invoice_date.toLocaleDateString("en-US", options);

    const created_date = new Date(selectedInvoices.invoice_date);
    const formatted_created_date = created_date.toLocaleDateString("en-US", options);

    const invoiceCSVHeaderTemplate = [
      [
        "Account Code",
        "Account Name",
        "Invoice Number",
        "Grand Total amount",
        "Salesman Name",
        "Invoice Date",
        "Created Date",
        "Product Name",
        "Product Code",
        "Uom",
        "Quantity",
        "Price with tax",
        "Subtotal",
      ],
    ];

    const csvBody = invoiceItems.map((items) => [
      selectedInvoices.account_code,
      selectedInvoices.account_name,
      selectedInvoices.invoice_number,
      total_value,
      salesman_name,
      formatted_invoice_date,
      formatted_created_date,
      items.product_name,
      items.product_code,
      items.uom,
      items.quantity_invoiced,
      items.price_with_tax,
      items.price_with_tax * items.quantity_invoiced,
    ]);

    const csv = [...invoiceCSVHeaderTemplate, ...csvBody];
    setInvoiceCSV(csv);
  }

  useEffect(() => {
    if (invoiceCSV.length === 0) {
      return;
    }
    downloadCsvInvoiceRef.current.link.click();
  }, [invoiceCSV]);

  const handleConnectToBluetooth = async () => {
    try {
      setShowProgressDialog(true);
      setProgressDialogMessage("Searching for your device... Please wait...");

      const available = await navigator.bluetooth.getAvailability();

      if (!available) {
        setShowProgressDialog(false);
        alert("Bluetooth is not available on this device.");
        return;
      }

      const device = await navigator.bluetooth.requestDevice({
        filters: [{ services: ["000018f0-0000-1000-8000-00805f9b34fb"] }],
      });

      setProgressDialogMessage("Connecting to device...");
      const server = await device.gatt.connect();

      setProgressDialogMessage("Getting primary service...");
      const service = await server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb");

      setProgressDialogMessage("Getting characteristic...");
      const characteristic = await service.getCharacteristic(
        "00002af1-0000-1000-8000-00805f9b34fb"
      );

      characteristicRef.current = characteristic;

      setIsBluetoothConnected(true);
    } catch (error) {
      console.error("Error connecting to Bluetooth:", error);
      setShowProgressDialog(false);
      alert("An error occurred while trying to connect to Bluetooth.");
    }
  };

  useEffect(() => {
    if (!downloadPDF) {
      return;
    }

    generatePDF();
  }, [downloadPDF]);

  const generatePDF = async () => {
    // console.log(selectedInvoices)
    // console.log(selectedInvoicesForPdf)
    // setDownloadPDF(false)
    // return
    try {
      const doc = new jsPDF();

      const invoice_date = new Date(selectedInvoices.invoice_date);
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formatted_invoice_date = invoice_date.toLocaleDateString("en-US", options);

      const account_info =
        selectedInvoices.account_name + " (" + selectedInvoices.account_code + ")";
      const number_of_uniques_sku_sold = selectedInvoices.number_of_uniques_sku_sold;
      const invoice_number = selectedInvoices.invoice_number;
      const total_value = parseFloat(selectedInvoices.total_value).toFixed(2);

      const created_date = new Date(selectedInvoices.invoice_date);
      const formatted_created_date = created_date.toLocaleDateString("en-US", options);
      const salesman_name =
        selectedInvoices.salesman_first_name +
        " " +
        selectedInvoices.salesman_middle_name +
        " " +
        selectedInvoices.salesman_last_name;

      const InvoiceItems = selectedInvoices.InvoiceItems;

      const lineHeight = 1.2;
      const labelSpacing = 5;

      const startX = 14;
      const startY = 22;

      let currentX = startX;
      let currentY = startY;

      doc.setFontSize(12);

      const title = "Sales Invoice Summary";

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const textWidth = doc.getTextDimensions(title).w;
      const textHeight = doc.getTextDimensions(title).h;

      const x = (pageWidth - textWidth) / 2;
      const y = 8;

      doc.setFont("helvetica", "bold");
      doc.text(title, x, y);

      const invoice_number_label = "INVOICE NUMBER :";
      doc.text(invoice_number_label, currentX, currentY);

      const invoiceNumberLabelWidth = doc.getTextDimensions(invoice_number_label).w;
      const invoiceNumberValueX = currentX + invoiceNumberLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(invoice_number, invoiceNumberValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(invoice_number_label).h * lineHeight;

      doc.setFont("helvetica", "bold");
      doc.text(title, x, y);

      const account_info_label = "ACCOUNT NAME :";
      doc.text(account_info_label, currentX, currentY);

      const accountInfoLabelWidth = doc.getTextDimensions(account_info_label).w;
      const accountInfoValueX = currentX + accountInfoLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(account_info, accountInfoValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(account_info_label).h * lineHeight;

      // NUMBER OF UNIQUE SKU SOLD
      doc.setFont("helvetica", "bold");
      const number_of_uniques_sku_sold_label = "NUMBER OF UNIQUE SKU SOLD :";
      doc.text(number_of_uniques_sku_sold_label, currentX, currentY);

      const poNumberLabelWidth = doc.getTextDimensions(number_of_uniques_sku_sold_label).w;
      const poNumberValueX = currentX + poNumberLabelWidth + labelSpacing;

      doc.setFont("helvetica", "normal");
      doc.text(number_of_uniques_sku_sold, poNumberValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(number_of_uniques_sku_sold_label).h * lineHeight;

      // INVOICE DATE
      doc.setFont("helvetica", "bold");
      const invoice_date_label = "INVOICE DATE :";
      doc.text(invoice_date_label, currentX, currentY);

      const invoiceDateLabelWidth = doc.getTextDimensions(invoice_date_label).w;
      const invoiceDateLabelValueX = currentX + invoiceDateLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(formatted_invoice_date, invoiceDateLabelValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(invoice_date_label).h * lineHeight;

      // CREATED DATE
      doc.setFont("helvetica", "bold");
      const created_date_label = "CREATED DATE :";
      doc.text(created_date_label, currentX, currentY);

      const createdDateLabelWidth = doc.getTextDimensions(created_date_label).w;
      const createdDateLabelValueX = currentX + createdDateLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(formatted_created_date, createdDateLabelValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(created_date_label).h * lineHeight;

      // SALESMAN NAME
      doc.setFont("helvetica", "bold");
      const salesman_name_label = "SALESMAN NAME :";
      doc.text(salesman_name_label, currentX, currentY);

      const salesmanNameLabelWidth = doc.getTextDimensions(salesman_name_label).w;
      const salesmanNameLabelValueX = currentX + salesmanNameLabelWidth + labelSpacing;
      doc.setFont("helvetica", "normal");
      doc.text(salesman_name, salesmanNameLabelValueX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(created_date_label).h * lineHeight;
      currentY += doc.getTextDimensions(created_date_label).h * lineHeight;

      doc.setFont("helvetica", "bold");
      const ordered_items_label = "INVOICE ITEMS";
      doc.text(ordered_items_label, currentX, currentY);

      // Move to the next line
      currentY += doc.getTextDimensions(ordered_items_label).h * 1;

      const columns = [
        "Product Name",
        "Product Code",
        "UOM",
        "Quantity",
        "Price with Tax",
        "Subtotal",
      ];
      const rows = InvoiceItems.map((item) => [
        item.product_name,
        item.product_code,
        item.uom,
        item.quantity_invoiced,
        item.price_with_tax,
        item.quantity_invoiced * item.price_with_tax,
      ]);

      // Add the table
      doc.autoTable({
        startY: currentY,
        head: [columns],
        body: rows,
        theme: "grid",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        styles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
      });

      const finalY = doc.lastAutoTable.finalY;
      doc.text(`Grand Total Amount: ${total_value}`, 14, finalY + 10);

      // Save the PDF
      doc.save("Sales Invoice Summary.pdf");
      setDownloadPDF(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!isBluetoothConnected || !selectedInvoices) {
      return;
    }

    const handlePrintViaBluetooth = async () => {
      try {
        setProgressDialogMessage("Printing Invoices... Please wait...");

        await printAccountInformation();
        await delay(1000);
        await printItems();
        await delay(1000);
      } catch (error) {
        setShowMessageDialog(true);
        setMessageDialogMessage(error);
        setShowProgressDialog(false);
      } finally {
        setShowMessageDialog(true);
        setMessageDialogMessage("Done Printing");

        setIsBluetoothConnected(false);
        setShowProgressDialog(false);
      }
    };

    handlePrintViaBluetooth();
  }, [isBluetoothConnected, selectedInvoices]);

  /**
   * Print Bluetooth Account Info
   */
  const printAccountInformation = async () => {
    const characteristic = characteristicRef.current;

    if (!characteristic) {
      console.error("Characteristic is not defined");
      return;
    }

    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment
    const Invoice = selectedInvoices;

    // Account Name
    const account_name_text = `Account Name: ${Invoice.account_name}\r\n`;
    const encoded_account_name_text = new TextEncoder().encode(account_name_text);
    await characteristic.writeValue(encoded_account_name_text);
    const account_name_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(account_name_command);
    await characteristic.writeValue(resetAlignment);

    // Account Code
    const account_code_text = `Account Code: ${Invoice.account_code}\r\n`;
    const encoded_account_code_text = new TextEncoder().encode(account_code_text);
    await characteristic.writeValue(encoded_account_code_text);
    const account_code_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(account_code_command);
    await characteristic.writeValue(resetAlignment);

    // Account Code
    const invoice_number_text = `Account Code: ${Invoice.invoice_number}\r\n`;
    const encoded_invoice_number_text = new TextEncoder().encode(invoice_number_text);
    await characteristic.writeValue(encoded_invoice_number_text);
    const invoice_number_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(invoice_number_command);
    await characteristic.writeValue(resetAlignment);

    // Number of Unique SKU Sold
    const number_of_uniques_sku_sold_text = `Number of Unique SKU Sold: ${Invoice.number_of_uniques_sku_sold}\r\n`;
    const encoded_number_of_uniques_sku_sold_text = new TextEncoder().encode(
      number_of_uniques_sku_sold_text
    );
    await characteristic.writeValue(encoded_number_of_uniques_sku_sold_text);
    const number_of_uniques_sku_sold_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(number_of_uniques_sku_sold_command);
    await characteristic.writeValue(resetAlignment);

    // Total Value
    const totalValueNumber = parseFloat(Invoice.total_value); // Convert string to number
    const roundedValue = totalValueNumber.toFixed(2);
    const total_value_text = `Total Value: ${roundedValue}\r\n`;
    const encoded_total_value_text = new TextEncoder().encode(total_value_text);
    await characteristic.writeValue(encoded_total_value_text);
    const total_value_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(total_value_command);
    await characteristic.writeValue(resetAlignment);

    // Invoice Date
    const invoice_date_date = new Date(Invoice.invoice_date);
    const invoice_date_options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const invoice_date_formattedDate = invoice_date_date.toLocaleDateString(
      "en-US",
      invoice_date_options
    );

    const invoice_date_text = `Invoice Date: ${invoice_date_formattedDate}\r\n`;
    const encoded_invoice_date_text = new TextEncoder().encode(invoice_date_text);
    await characteristic.writeValue(encoded_invoice_date_text);
    const invoice_date_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(invoice_date_command);
    await characteristic.writeValue(resetAlignment);

    // Created Date
    const date = new Date(Invoice.created);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);

    const created_date_text = `Created Date: ${formattedDate}\r\n`;
    const encoded_created_date_text = new TextEncoder().encode(created_date_text);
    await characteristic.writeValue(encoded_created_date_text);
    const created_date_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(created_date_command);
    await characteristic.writeValue(resetAlignment);

    const divider = "********************************\r\n";
    const divideData = new TextEncoder().encode(divider);
    await characteristic.writeValue(divideData);
    const centerCommand = new Uint8Array([0x1b, 0x61, 0x01]); // ESC a 0x01 - center alignment
    await characteristic.writeValue(centerCommand);
  };

  const printItems = async () => {
    const InvoiceItems = selectedInvoices.InvoiceItems;
    const characteristic = characteristicRef.current;

    if (!characteristic) {
      console.error("Characteristic is not defined");
      return;
    }

    if (InvoiceItems.length === 0) {
      return;
    }

    // Write a command to the printer to reset the text alignment
    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

    // Spaces
    const spaces = "\r\n";
    const spaces_data = new TextEncoder().encode(spaces);
    await characteristic.writeValue(spaces_data);
    const command4 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command4);
    await characteristic.writeValue(resetAlignment);

    for (const items of InvoiceItems) {
      await printProductElements(items);
    }

    await characteristic.writeValue(spaces_data); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command4);
    await characteristic.writeValue(resetAlignment);

    const divider = "********************************\r\n";
    const divideData = new TextEncoder().encode(divider);
    await characteristic.writeValue(divideData);
    const centerCommand = new Uint8Array([0x1b, 0x61, 0x01]); // ESC a 0x01 - center alignment
    await characteristic.writeValue(centerCommand);

    const computedAmount = computeTotalSalesOrderAmount();
    console.log(computedAmount);
    const total = "Total : " + computedAmount + "\r\n";
    const total_data = new TextEncoder().encode(total);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(total_data);
    const command5 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command5);
    await characteristic.writeValue(resetAlignment);
  };

  const printProductElements = async (product) => {
    const characteristic = characteristicRef.current;

    // Write a command to the printer to reset the text alignment
    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

    const product_name =
      product.product_name !== undefined ? product.product_name + "\r\n" : "NO PRODUCT NAME\r\n";
    const product_name_data = new TextEncoder().encode(product_name);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(product_name_data);
    const command2 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command2);
    await characteristic.writeValue(resetAlignment);

    await delay(1000);

    const computation =
      product.price_with_tax +
      " x " +
      product.quantity_invoiced +
      " " +
      product.uom +
      " = " +
      Number((product.price_with_tax * product.quantity_invoiced).toFixed(2)).toLocaleString(
        "en-US",
        { maximumFractionDigits: 2 }
      ) +
      "\r\n";
    const computation_data = new TextEncoder().encode(computation);
    await characteristic.writeValue(computation_data);
    const command3 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command3);
    await characteristic.writeValue(resetAlignment);
  };

  const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const computeTotalSalesOrderAmount = () => {
    const InvoiceItems = selectedInvoices.InvoiceItems;

    const totalInvoicedValue = Number(
      InvoiceItems.reduce((partialSum, product) => {
        // Parse price_with_tax to a floating-point number
        const priceWithTax = parseFloat(product.price_with_tax);

        // Check if the parsed value is a valid number
        if (isNaN(priceWithTax)) {
          console.error("Invalid price_with_tax:", product.price_with_tax);
          return partialSum; // Ignore invalid value and return current partial sum
        }

        // Parse quantity_invoiced to a floating-point number
        const quantityInvoiced = parseFloat(product.quantity_invoiced);

        // Calculate the partial sum for the current product
        const productTotal = priceWithTax * quantityInvoiced;

        return partialSum + productTotal;
      }, 0)
    );

    return totalInvoicedValue.toFixed(2);
  };

  const progressDialog = () => {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={showProgressDialog} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>{progressDialogMessage}</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  };

  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function generatePurchaseOrder() {
    return (
      <List>
        {salesInvoices.map((salesInvoice) => (
          <ListItem button divider key={salesInvoice.id}>
            {salesInvoiceItem(salesInvoice)}
          </ListItem>
        ))}
      </List>
    );
  }
  function dateRangeFilterDialog() {
    return (
      <Dialog
        fullWidth={true}
        open={openDateFilterDialog}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Filter date"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      value={startingDate}
                      open={openStartingDateCalendar}
                      onChange={(date) => {
                        setStartingDate(date);
                      }}
                      onOpen={() => setOpenStartingDateCalendar(true)}
                      onClose={() => setOpenStartingDateCalendar(false)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Starting date"}
                          style={{ width: "99%", margin: "1%" }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={() => {
                                    setOpenStartingDateCalendar(true);
                                  }}
                                >
                                  <EventIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      value={endingDate}
                      open={openEndingDateCalendar}
                      onChange={(date) => {
                        setEndingDate(date);
                      }}
                      onOpen={() => setOpenEndingDateCalendar(true)}
                      onClose={() => setOpenEndingDateCalendar(false)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={"Ending Date"}
                          style={{ width: "99%", margin: "1%" }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={() => {
                                    setOpenEndingDateCalendar(true);
                                  }}
                                >
                                  <EventIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDateFilterDialog(false);
              setStartingFilterDate(startingDate);
              setEndingFilterDate(endingDate);
              setLoadData(true);
              //getSalesInvoices(searchTerm.name)
            }}
            color="primary"
            autoFocus
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  // useEffect(()=>{
  //   format(startingFilterDate, 'yyyy-MM-dd')
  // },[endingDate])

  // useEffect(()=>{

  //   if(!loadData){
  //     //do nothing
  //     return
  //   }
  //   getSalesInvoiceFilterByAccount(searchTerm.name)
  //   setLoadData(false)

  // },[loadData])

  useEffect(() => {
    if (!loadData) {
      //do nothing
      return;
    }
    getSalesInvoices(searchTerm.name);
    setLoadData(false);
  }, [loadData]);

  useEffect(() => {
    if (searchBy == "search_by_account_name") {
      fetchAccountForAutoSuggest(searchTerm.name);
    } else {
      fetchSalesmanForAutoSuggest(searchTerm.name);
    }
  }, [searchTerm]);

  function getSalesInvoices(searchTerm) {
    if (searchBy == "search_by_account_name") {
      getSalesInvoiceFilterByAccount(searchTerm);
    } else {
      getSalesInvoiceFilterBySalesman(searchTerm);
    }
  }
  function getSalesInvoiceFilterByAccount(searchTerm) {
    setIsLoading(true);

    const options = {
      method: "POST",
      url: "/TransactiInvoiceInformations/getSalesInvoices.json",
      data: objectToFormData({
        search_term: searchTerm,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }

        setSalesInvoices(res.data.response.SalesInvoices);
        setTotalFilteredInvoiceSalesAmount(res.data.response.total_invoiced_amount);
        setTotalFilteredInvoiceCount(res.data.response.total_invoice_count);
        setTotalUniqueSKUcount(res.data.response.total_unique_sku_count);
        setTotalPerInvoiceUniqueSkuCount(res.data.response.total_per_invoice_unique_sku_count);

        //setSalesOrders(res.response.sales_orders)

        // setIsSavingSuccess(true)
        // setIsSavingAccount(false)
        // setMessageDialogMessage("Account save successfully.")
        // setShowMessageDialog(true)
      })
      .catch((error) => {
        setIsLoading(false);

        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }
  function getSalesInvoiceFilterBySalesman(searchTerm) {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiInvoiceInformations/getSalesInvoicesSearchBySalesman.json",
      data: objectToFormData({
        search_term: searchTerm,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        const isSuccess = res.data.response.is_success;
        if (!isSuccess) {
          alert("Error encounter");
          return;
        }

        setSalesInvoices(res.data.response.SalesInvoices);
        setSalesInvoices(res.data.response.SalesInvoices);
        setTotalFilteredInvoiceSalesAmount(res.data.response.total_invoiced_amount);
        setTotalFilteredInvoiceCount(res.data.response.total_invoice_count);
        setTotalUniqueSKUcount(res.data.response.total_unique_sku_count);

        //setSalesOrders(res.response.sales_orders)

        // setIsSavingSuccess(true)
        // setIsSavingAccount(false)
        // setMessageDialogMessage("Account save successfully.")
        // setShowMessageDialog(true)
      })
      .catch((error) => {
        setIsLoading(false);

        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }

  function fetchAccountForAutoSuggest(searchTerm) {
    setAutoCompleteSearchOptionMessage("Searching...");
    const options = {
      method: "POST",
      url: "/SellerAccounts/getSellerAccountsForAutoSuggest.json",
      data: objectToFormData({
        search_term: searchTerm,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
      }),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }
        const suggestedAccounts = res.data.response.seller_accounts;
        if (suggestedAccounts.length <= 0) {
          setAutoCompleteSearchOptionMessage("No record found");
        }

        setAutoSuggestAccounts(suggestedAccounts);
        // setIsSavingSuccess(true)
        // setIsSavingAccount(false)
        // setMessageDialogMessage("Account save successfully.")
        // setShowMessageDialog(true)
      })
      .catch((error) => {
        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }
  function fetchSalesmanForAutoSuggest(searchTerm) {
    setAutoCompleteSearchOptionMessage("Searching...");
    const options = {
      method: "POST",
      url: "/TransactiInvoiceInformations/getSalesmanWithTransactionForAutoSuggest.json",
      data: objectToFormData({
        search_term: searchTerm,
        start_date: format(startingFilterDate, "yyyy-MM-dd"),
        end_date: format(endingFilterDate, "yyyy-MM-dd"),
      }),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }
        const suggestedSalesman = res.data.response.salesmans;
        if (suggestedSalesman.length <= 0) {
          setAutoCompleteSearchOptionMessage("No record found");
        }

        setAutoSuggestSalesman(suggestedSalesman);
        // setIsSavingSuccess(true)
        // setIsSavingAccount(false)
        // setMessageDialogMessage("Account save successfully.")
        // setShowMessageDialog(true)
      })
      .catch((error) => {
        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="subtitle1" noWrap>
            Sales Invoice Summary
          </Typography>
        </Toolbar>
      </AppBar>
      {searchBy == "search_by_account_name" ? searchAccountName() : searchBySalesman()}
      {isLoading ? (
        <LinearProgress color="secondary" style={{ marginLeft: ".1rem", marginRight: ".1rem" }} />
      ) : (
        ""
      )}
      {headerSummary()}
      {generatePurchaseOrder()}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {dateRangeFilterDialog()}
          {orderMoreVertDropdownMenu()}
          {progressDialog()}
          {messageDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
      {
        <SalesInvoiceProducts
          selectedInvoice={selectedInvoice}
          openSaleOrderProductDialog={openSaleOrderProductDialog}
          setOpenSaleOrderProductDialog={setOpenSaleOrderProductDialog}
        />
      }

      {selectedInvoices && (
        <EditSalesInvoiceSummary
          selectedInvoices={selectedInvoices}
          setSelectedInvoices={setSelectedInvoices}
          setOpenEditInvoiceDialog={setOpenEditInvoiceDialog}
          openEditInvoiceDialog={openEditInvoiceDialog}
          setLoadData={setLoadData}
          setOrderMenuAnchorElement={setOrderMenuAnchorElement}
        />
      )}
    </div>
  );
}

export default ViewSalesInvoiceSummary;
